import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as IconChecker } from '../../../../assets/images/checker.svg';
import { ProductTypes } from '../../../../models/products.model';
import './index.scss';
import { dataProductFull } from '../../../../store/location';
import { togglePopup } from '../../../../store/ui';
import pushToDataLayer from '../../../../utils/pushToDataLayer';

import SujetCheckModal from '../sujetCheckModal';

const Checker: FC<{ productdata: any }> = ({ productdata }) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const { data: productData = null } = useSelector(dataProductFull);
    const isSujetcheckInfoSet = !!productData?.sujetcheckinformation;

    if (isSujetcheckInfoSet) {
        return (
            <a
                className={'checker-link'}
                target="_blank"
                rel="noreferrer"
                onClick={() => {
                    dispatch(togglePopup({ name: 'sujet_upload_and_check', status: true, payload: [productdata] }));
                }}
            >
                <IconChecker />
                {intl.formatMessage({ id: 'general.checker', defaultMessage: 'Sujetcheck' })}
            </a>
        );
    }

    return null;
};

export default Checker;
